import Phaser from 'phaser';
import { validateLevels } from '../../content/levels';
import { createGameTextures } from '../art';
import { audio } from '../systems/AudioManager';
import { ProgressStore } from '../systems/ProgressStore';

export class BootScene extends Phaser.Scene {
  constructor() {
    super('Boot');
  }

  preload(): void {
    this.cameras.main.setBackgroundColor(0x000000);
    this.load.image('menu-bg', 'assets/generated/intro/frog-house-menu-bg.png');
    this.load.image('intro-kumek', 'assets/generated/intro/kumek.png');
    this.load.image('intro-babel', 'assets/generated/intro/babel.png');
    const levelBackgrounds = [
      'level-01-frog-house',
      'level-02-wojska-square',
      'level-03-market',
      'level-04-castle',
      'level-05-factory',
      'level-06-station',
      'level-07-gondola',
      'level-08-summit',
      'level-09-library',
      'level-10-blonia',
      'level-11-sfera',
    ];
    levelBackgrounds.forEach((filename, index) => {
      this.load.image(`level-bg-${index + 1}`, `assets/generated/levels/${filename}.png`);
    });
  }

  create(): void {
    const errors = validateLevels();
    if (errors.length > 0) throw new Error(errors.join('\n'));
    createGameTextures(this);
    const save = new ProgressStore().load();
    audio.setMuted(save.muted);
    this.sound.mute = save.muted;
    this.scene.start('Menu', { playIntro: true });
  }
}
